<div class="agpr-includeExclude-container">
    <div class="agpr-includeExclude-headerLabelContainer">
        <agpr-button
            class="agpr-includeExclude-expandButton"
            [style]="buttonTypes.link"
            [icon]="expanded ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-right'"
            [disabled]="expanded && (value?.exclude?.length > 0 || value?.includeAll?.length > 0)"
            [expanded]="expanded"
            (click)="toggleExpanded()"
            [ariaLabel]="
                (('Discover.targeting.searchFieldLabels.mediaMarkets' | localize) + '. '
                + ('Discover.targeting.searchFieldLabels.expandButton.tooltip' | localize) + '. ' + ('tooltipDetails' | localize))"
        >
            <label
                [id]="id + '_label'"
                class="agpr-includeExclude-headerLabel"
            >
                {{ 'Discover.targeting.searchFieldLabels.mediaMarkets' | localize }}
            </label>
        </agpr-button>
        <span
            role="img"
            class="agpr-includeExclude-infoIconStyle fa-regular fa-circle-info"
            agprTooltip="Discover.targeting.searchFieldLabels.mediaMarkets.tooltip"
            tabindex="0"
        ></span>
    </div>
    <div
        class="agpr-includeExclude-chipsContainer"
        role="group"
        [attr.aria-labelledby]="id + '_label'"
    >
        <div class="agpr-mediaMarket-rowGroup">
            <label
                [for]="id + '_autocomplete_include'"
                [@labelState]="expanded ? 'visible' : 'hidden'"
            >
                {{ 'or' | localize }}
            </label>
            <ng-container
                *ngTemplateOutlet="autocompleteChip; context: {
                    mediaMarkets: value.include,
                    includeExclude: includeOrExclude.include
                }"
            ></ng-container>
        </div>
        <div
            [@containerState]="expanded ? 'visible' : 'hidden'"
            class="agpr-includeExclude-chipsContainer--expanded agpr-includeExclude-chipsContainer--expanded-subject"
            [style.display]="expanded ? 'grid' : 'none'"
        >
            <div class="agpr-mediaMarket-rowGroup">
                <label
                    [for]="id + '_autocomplete_includeAll'"
                    class="agpr-includeExclude-chipRow-expandedLabel"
                >
                    {{ 'and' | localize }}
                </label>
                <ng-container
                    *ngTemplateOutlet="autocompleteChip; context: {
                        mediaMarkets: value.includeAll,
                        includeExclude: includeOrExclude.includeAll
                    }"
                ></ng-container>
            </div>
            <div class="agpr-mediaMarket-rowGroup">
                <label
                    [for]="id + '_autocomplete_exclude'"
                    class="agpr-includeExclude-chipRow-expandedLabel"
                >
                    {{ 'not' | localize }}
                </label>
                <ng-container
                    *ngTemplateOutlet="autocompleteChip; context: {
                        mediaMarkets: value.exclude,
                        includeExclude: includeOrExclude.exclude
                    }"
                ></ng-container>
            </div>
        </div>
    </div>
</div>

<!-- eslint-disable @angular-eslint/template/role-has-required-aria, @angular-eslint/template/interactive-supports-focus -->
<!-- Grouped Autocomplete Templates -->
<ng-template
    #overlayTemplate
    let-suggestions="suggestions"
>
    @if (!suggestions || suggestions.length === 0) {
        <li role="option">
            <agpr-message
                class="agpr-subject-chips-noContent"
                [severity]="messageSeverityEnum.noContent"
            >
                <span>
                    {{ 'Discover.targeting.searchFieldLabels.noContentMessage.mediaMarket' | localize }}
                </span>
            </agpr-message>
        </li>
    }
</ng-template>

<ng-template
    #autocompleteChip
    let-mediaMarkets="mediaMarkets"
    let-includeExclude="includeExclude"
>
    @if (mediaMarkets) {
        <div
            class="agpr-mediaMarket-col"
            [class.agpr-mediaMarket--hasChips]="mediaMarkets.length > 0"
        >
            <div class="agpr-inputGroupRow">
                <agpr-grouped-autocomplete
                    #autocomplete
                    class="agpr-mediaMarket-autocomplete"
                    [id]="id + '_autocomplete_' + includeExclude"
                    labelField="name"
                    [placeholder]="'Discover.targeting.searchFieldLabels.search.placeholder' | localize"
                    [clearOnBlur]="true"
                    [showEmptyMessage]="true"
                    [suggestionsFetcher]="journodexEnumsService.mediaMarketGroup.bind(journodexEnumsService)"
                    optionGroupChildren="items"
                    [groupTemplate]="groupTemplate"
                    [itemsListTemplate]="itemsListTemplate"
                    [overlayTemplate]="overlayTemplate"
                    [forceClearAfterSelection]="true"
                    (itemSelected)="addChip($event, includeExclude)"
                    (viewAllInGroup)="autocompleteBrowseAllClicked.emit({ parent: $event })"
                    [ariaDescribedBy]="id + '_values'"
                ></agpr-grouped-autocomplete>
                <agpr-button
                    [style]="buttonTypes.block"
                    class="agpr-mediaMarket-manageButton"
                    icon="fa-regular fa-duotone fa-binoculars"
                    tooltip="Monitoring.search.browseAll"
                    tooltipPosition="top"
                    (click)="browseAll.emit({
                        includeOrExclude: includeExclude
                    })"
                    ariaLabel="Monitoring.search.browseAll"
                ></agpr-button>
            </div>
            @if (mediaMarkets.length > 0) {
                <div
                    #chipList
                    class="agpr-mediaMarket-chipArea"
                    role="group"
                    [attr.aria-labelledby]="ariaLabelledBy"
                >
                    @for (mediaMarket of mediaMarkets | groupBy: 'type' | keyvalue; track mediaMarket.id; let j = $index) {
                        <div class="chips-row">
                            <div class="chips-row-headerContainer">
                                @if (mediaMarket.value.length > 0) {
                                    <span
                                        [id]="id + '_mediaMarketRow_' + j + '_label'"
                                        class="chips-row-parent"
                                    >
                                        {{ mediaMarketGroupMap.get(mediaMarket.key) }}
                                    </span>
                                }
                                <div class="chips-row-trash-container">
                                    <agpr-button
                                        [id]="id + '_mediaMarketRow_' + j + '_delete'"
                                        [style]="buttonTypes.icon"
                                        icon="fa-kit-duotone fa-agpr-remove-all"
                                        (click)="removeGroup(mediaMarket.key, includeExclude, mediaMarkets)"
                                        class="chips-row-trash"
                                        tooltip="Discover.dialogs.browsers.subject.delete"
                                        [ariaLabel]="('Discover.dialogs.browsers.subject.delete' | localize) + ' in category ' + mediaMarket.key"
                                    ></agpr-button>
                                </div>
                            </div>
        
                            @if (mediaMarket.value.length > 0) {
                                <agpr-chips
                                    [id]="id + '_mediaMarketRow_' + j + '_chips'"
                                    [(ngModel)]="mediaMarket.value"
                                    (ngModelChange)="handleChanges(includeExclude, $event)"
                                    [ignorePadding]="true"
                                    labelFieldName="displayString"
                                    [ariaLabelledBy]="id + '_mediaMarketRow_' + j + '_label'"
                                    [handleFocus]="false"
                                    [clearAllChipsButton]="false"
                                ></agpr-chips>
                            }
                        </div>
                    }
                </div>
            }
            <div
                [id]="id + '_values'"
                class="u-srOnly"
            >
                @for (mediaMarket of mediaMarkets | groupBy: 'type' | keyvalue; track mediaMarket.id) {
                    <ul role="group">
                        {{ mediaMarket.key | localize }} Group
                        @for (obj of mediaMarket.value; track subject) {
                            <li>
                                {{ obj.displayString }}
                            </li>
                        }
                    </ul>
                }
            </div>
        </div>
    }
</ng-template>

<ng-template
    #groupTemplate
    let-group
    let-index="groupIdx"
    pTemplate="group"
>
    <div class="agpr-mediaMarket-dropdown">
        <span class="agpr-mediaMarket-dropdown-name">
            {{ group.label }}
        </span>
        <agpr-button
            [style]="buttonTypes.block"
            class="agpr-mediaMarket-manageButton"
            icon="fa-regular fa-duotone fa-binoculars"
            [tooltip]="'Discover.dialogs.browseAll.subSubjects' | localize : { subject: group.displayString }"
            (click)="browseAll.emit({
                includeOrExclude: includeOrExclude.include,
                parentType: group.type,
                childId: group.items[0]?.id
            })"
        ></agpr-button>
    </div>
</ng-template>

<ng-template #itemsListTemplate
    let-suggestionsToDisplay
    let-itemSelectedFn="selectItem"
    let-index="groupIdx"
    let-group="group"
>
    @for (option of group.items | slice:0:5; track option.id; let idx = $index) {
        <li
            role="option"
            class="agpr-mediaMarket-dropdown-itemContainer"
            [id]="option.id"
            (click)="itemSelectedFn(option)"
        >
            <div class="agpr-mediaMarket-dropdown-item">
                <span> {{ option.displayString }} </span>
            </div>
        </li>
    }
</ng-template>
